import { render, staticRenderFns } from "./mobile-app-modal.vue?vue&type=template&id=67a18428&scoped=true&"
import script from "./mobile-app-modal.vue?vue&type=script&lang=js&"
export * from "./mobile-app-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a18428",
  null
  
)

export default component.exports